import { atom } from 'jotai';
import { atomWithReset, atomWithStorage } from 'jotai/utils';
import { ServerStep, WorkflowServerExpect } from './ServerWorkflowType';
import { findStepById } from './workflowTreeUtils';

const initialWorkflow: WorkflowServerExpect = {
  businessProduct: '',
  cronTimezone: '',
  cronTrigger: '',
  deprecated: false,
  description: '',
  disabled: false,
  eventParametersMapping: '',
  failbackStepGroup: null,
  ftpDropzone: '',
  name: '',
  nextStepGroup: null,
  notifyEmails: '',
  productGroup: null,
  reportingIndex: '',
  s3AccessKey: '',
  s3Dropzone: '',
  s3PrivateKey: '',
  s3RoleArn: '',
  s3RoleSessionName: '',
  sftpDropzone: null,
  sftpPrivateKey: null,
  slave: 'test',
  strictDropzoneOrdering: false,
  supportResubmit: false,
  supportsPrioritization: false,
  tenant: null,
  throttleRate: 1,
  timeoutAfter: null,
  topicId: null,
  unpackInput: false,
  workflowId: null,
};

export const workflowAtom = atomWithReset(initialWorkflow);

// Internal atom to store only the selected step ID
export const selectedStepIdAtom = atom<number | null>(null);

// Derived atom that finds and returns the step from workflowAtom
export const selectedStepAtom = atom(
  (get) => {
    const workflow = get(workflowAtom);
    const stepId = get(selectedStepIdAtom);

    if (!stepId) {
      return null;
    }

    // Search in both nextStepGroup and failbackStepGroup
    let step: ServerStep | null = null;

    if (workflow.nextStepGroup) {
      step = findStepById(workflow.nextStepGroup, stepId);
    }

    if (!step && workflow.failbackStepGroup) {
      step = findStepById(workflow.failbackStepGroup, stepId);
    }

    return step;
  },
  (get, set, update: ServerStep | null) => {
    // When setting, store the workflowStepId
    if (update && update.workflowStepId) {
      set(selectedStepIdAtom, update.workflowStepId);
    } else {
      set(selectedStepIdAtom, null);
    }
  }
);

export const isSidePanelOpenAtom = atom<boolean>(false);
export const isSidePanelStepOpenAtom = atom<boolean>(false);
export const disableBackgroundColorAtom = atomWithStorage<boolean>(
  'disableBackgroundColor',
  true
);
export const isCompactAtom = atomWithStorage<boolean>('isCompact', true);
export const hideDropZoneIconsAtom = atomWithStorage<boolean>(
  'hideDropZoneIcons',
  true
);
export const hideDropZoneTextAtom = atomWithStorage<boolean>(
  'hideDropZoneText',
  true
);
export const hideStepInfoAtom = atomWithStorage<boolean>('hideStepInfo', true);
export const hideTooltipInfoAtom = atomWithStorage<boolean>(
  'hideTooltipInfo',
  true
);

// Module filter atom - for searching/filtering modules
export const moduleFilterAtom = atom<string>('');

// Selected CSB Worker atom - filters the Custom Modules section of the module library only
export const workerFilterAtom = atom<string>('');
